import { Contract } from '../codegen/graphql';

export function isContractValid(contract: Contract | null | undefined): boolean {
    if (!contract) return false;
    if (!contract.contractDurationTo) return false;
    return new Date() <= new Date(contract.contractDurationTo);
}

/**
 * True only when a contract exists but its duration has already passed.
 * "No contract at all" is NOT expired — that is handled separately.
 */
export function isContractExpired(contract: Contract | null | undefined): boolean {
    if (!contract?.id) return false;
    if (!contract.contractDurationTo) return false;
    return new Date() > new Date(contract.contractDurationTo);
}

/**
 * Effective IoT-data access rule: viewable when the contract is valid, or for IoT
 * admins (globalAdmin / regionAdmin) regardless of contract state — expired AND
 * missing contracts stay visible to them so live devices are never hidden. Connecting
 * new devices is gated on a strictly valid contract and is intentionally not covered here.
 */
export function canViewIoT(contract: Contract | null | undefined, isIoTAdmin: boolean): boolean {
    return isContractValid(contract) || isIoTAdmin;
}
